import { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCities } from '../redux/actions/city';
import { getCompanies, getCompanyById } from '../redux/actions/company';
import { getStates } from '../redux/actions/state';
import { getCountries } from '../redux/actions/country';
import { useUser } from './UserContext';
import { userGlobalSettings } from '../redux/actions/settings';
import { updateUserHistory } from '../redux/actions/user';
import { useNavigate } from 'react-router-dom';

const GlobalContext = createContext({
   cityList: [],
   stateList: [],
   countryList: [],
   companyList: [],
   userGlobalSettings: [],
});

export const useGlobal = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
   const { user } = useUser();
   const cityList = useSelector((state) => state.city.list);
   const stateList = useSelector((state) => state.state.list);
   const countryList = useSelector((state) => state.country.list);
   const companyList = useSelector((state) => state.company.list);
   const companyType = localStorage.getItem('selectedCompanyType');
   const company = companyList.find(
      (comp) =>
         comp.id === user?.loginhistory?.companyId &&
         (companyType === "shared" ? comp.isShared : !comp?.isShared)
   );
   const userGlobalSettingsData = useSelector((state) => state?.users?.globalSettings);
   const dispatch = useDispatch();
   const navigate = useNavigate();

   useEffect(() => {
      const fetchData = async () => {
         dispatch(getCities());
         dispatch(getStates());
         dispatch(getCountries());

         const res = await dispatch(getCompanies());
         dispatch(userGlobalSettings());

         if (res && res?.data?.length === 0) {
            console.log("Company list is empty, fetching companies");
            navigate('/auth/create-comp');
         }

         if (res) {
            const company = res?.data?.find((comp) => comp.id === user?.loginhistory?.companyId);
            console.log("profiler", res, company, user?.loginhistory?.companyId);
            if (!company && user?.loginhistory?.companyId) {
               dispatch(updateUserHistory({ companyId: res?.data[0]?.id, code: res?.data[0]?.dbName ? res?.data[0]?.dbName : '' }));
            }
         }
      };

      fetchData();
   }, [dispatch, user?.loginhistory?.companyId]);

   return (
      <GlobalContext.Provider
         value={{ cityList, stateList, countryList, companyList, company, userGlobalSettingsData }}>
         {children}
      </GlobalContext.Provider>
   );
};
